export default __webpack_public_path__ + "d2760f94c1f7e0f6b979b59a56e39fe1.png";